import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';
import { isMobile } from 'react-device-detect';
import usePricingDistributionMasterTemplate, {
  PricingDistributionMasterTemplateAction,
} from './PricingDistributionMasterTemplate.Hooks';
import PricingDistributionMasterTemplateList from './sections/PricingDistributionMasterTemplate.List';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import PricingDistributionMasterTemplateFilters from './sections/PricingDistributionMasterTemplate.Filters';
import PricingDistributionMasterTemplateEdit from './sections/PricingDistributionMasterTemplate.Edit';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const pricingDistributionMasterTemplateIndexRoute =
  productManagementHomeRoute + '/pricingDistributionMasterTemplate/:action?/:id?';
export default function PricingDistributionMasterTemplateIndex() {
  const { lang } = getLocales();
  const pricingDistributionMasterTemplateHook = usePricingDistributionMasterTemplate();

  if (!pricingDistributionMasterTemplateHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={pricingDistributionMasterTemplateHook}
        render={({ listApi, pageRouter, permissions, views }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            style={{ pageContent: { overflow: 'auto' } }}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.pricingDistributionMasterTemplates} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <PricingDistributionMasterTemplateFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.ACCESS_PRICINGDISTRIBUTIONMASTERTEMPLATE}
                    data={{ action: PricingDistributionMasterTemplateAction.EDIT }}
                    htmlElementProps={{ title: lang.addNew }}
                  />
                </Box>
              </>
            }
            subHeader={!isMobile && <PricingDistributionMasterTemplateFilters />}
            render={
              <>
                <PricingDistributionMasterTemplateList />
                {views.edit && <PricingDistributionMasterTemplateEdit />}
              </>
            }
          />
        )}
      />
    </>
  );
}
